export function saveState(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}

export function getSavedState(key) {
    const savedState = localStorage.getItem(key);

    return savedState ? JSON.parse(savedState) : null;
}

export function clearSavedState(key) {
    localStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./assets/js/libs/local-storage.js